module.exports = __webpack_public_path__ + "img/wiping-swipe-for-floors-orange.eedd4108.svg";